<template>
  <transition name="slide-fade">
    <div>
      <v-navigation-drawer
          v-model="drawer"
          :class="baseColor"
          :clipped="clipped"
          :mini-variant="miniVariant"
          app
          dark
          fixed
          mini-variant-width="100"
          width="280"
      >
        <app-sidebar :mini-variant="miniVariant"/>
      </v-navigation-drawer>
      <v-app-bar
          :class="baseColor"
          :clipped-left="clipped"
          dark
          dense
          elevation="1"
          height="60"
      >
        <v-app-bar-nav-icon @click.stop="miniVariant = !miniVariant"></v-app-bar-nav-icon>
        <v-btn
            icon
            @click.stop="drawer = !drawer"
            style="margin: 6px 0px"
        >
          <v-icon>{{ `chevron_${drawer ? 'right' : 'left'}` }}</v-icon>
        </v-btn>
        <v-chip
            class="mr-2"
            color="success"
            link
            to="/invoices"
        >
         Reseller Invoice List
        </v-chip>
        <v-chip
            class="mr-2"
            color="#d243e7"
            link
            to="/invoice"
        >
          Create New Invoice
        </v-chip>
        <v-spacer/>
        <republish-notification v-if="user && (user.role_id === 1 || user.email ==='saykatzetrank@gmail.com')"/>
        <div class="mx-2"></div>
        <invoice-notification v-if="user && user.role_id === 1"/>
<!--        <notification v-if="user && user.role_id === 1"/>-->
        <div class="mx-2"></div>
        <user-menu/>
      </v-app-bar>
    </div>
  </transition>
</template>

<script>
import AppSidebar from "../components/menu/AppSidebar";
import UserMenu from "../components/user/UserMenu";
import Notification from "../components/Notification";
import UserMixin from "../components/mixins/UserMixin";
import InvoiceNotification from "@/components/notification/InvoiceNotification";
import RepublishNotification from "@/components/notification/RepublishNotification";

export default {
  name: "AppHeader",
  components: {RepublishNotification, InvoiceNotification, Notification, UserMenu, AppSidebar},
  mixins: [UserMixin],
  data() {
    return {
      /*baseColor: 'deep-purple accent-4',*/
      clipped: false,
      drawer: false,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'ShopRoller',
      icon: 'shopping_cart'
    }
  },
  computed: {
    baseColor(){
      if (!this.$vuetify.theme.dark){
        return 'deep-purple accent-4';
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer--mini-variant .v-list-item > *:nth-child(3) {
  position: relative !important;
  height: 25px !important;
  width: 25px !important;
}

.v-navigation-drawer--mini-variant .v-list-item > :first-child {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.v-navigation-drawer--mini-variant .v-list-group__header {
  padding-right: 0 !important;
}
</style>
